export const getWaterScarcityVars = {}
